/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The largest is maxresdefault at 1280×720. Not every video has it — YouTube only generates it when the source upload is high enough quality.`)
};

const es_yt_hd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La más grande es maxresdefault, de 1280×720. No todos los videos la tienen — YouTube solo la genera cuando el video original se subió con suficiente calidad.`)
};

const de_yt_hd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die größte ist maxresdefault mit 1280×720. Nicht jedes Video hat sie — YouTube erzeugt sie nur, wenn der Original-Upload eine ausreichend hohe Qualität hat.`)
};

const nl_yt_hd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De grootste is maxresdefault op 1280×720. Niet elke video heeft deze — YouTube genereert hem alleen als de originele upload van voldoende kwaliteit is.`)
};

const fr_yt_hd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La plus grande est maxresdefault, en 1280×720. Toutes les vidéos ne l’ont pas — YouTube ne la génère que lorsque la vidéo source a été mise en ligne dans une qualité suffisante.`)
};

const it_yt_hd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La più grande è maxresdefault a 1280×720. Non tutti i video ce l'hanno — YouTube la genera solo quando il video caricato è di qualità sufficientemente alta.`)
};

const pt_br2_yt_hd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maior é a maxresdefault, em 1280×720. Nem todo vídeo tem essa versão — o YouTube só a gera quando o upload original tem qualidade suficiente.`)
};

const pt_yt_hd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maior é o maxresdefault, a 1280×720. Nem todos os vídeos a têm — o YouTube só a gera quando o vídeo original foi carregado com qualidade suficientemente alta.`)
};

const ja_yt_hd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大サイズは1280×720のmaxresdefaultです。すべての動画にあるわけではなく、アップロード元の画質が十分に高い場合にのみYouTubeが生成します。`)
};

const zh_yt_hd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大尺寸是 1280×720 的 maxresdefault。并非每个视频都有这个尺寸 — 只有当原始上传画质足够高时，YouTube 才会生成它。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hd_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hd_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hd_faq1_a", locale)
	if (locale === "en") return en_yt_hd_faq1_a(inputs)
	if (locale === "es") return es_yt_hd_faq1_a(inputs)
	if (locale === "de") return de_yt_hd_faq1_a(inputs)
	if (locale === "nl") return nl_yt_hd_faq1_a(inputs)
	if (locale === "fr") return fr_yt_hd_faq1_a(inputs)
	if (locale === "it") return it_yt_hd_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hd_faq1_a(inputs)
	if (locale === "pt") return pt_yt_hd_faq1_a(inputs)
	if (locale === "ja") return ja_yt_hd_faq1_a(inputs)
	return zh_yt_hd_faq1_a(inputs)
};